class IndexRecentlyViewed extends HTMLElement {
    constructor() {
        super();
        this.wrapper = this.querySelector('.js-recently-viewed-wrapper');
        this.splitContainer = this.querySelector('.js-recently-viewed-split-container');
        this.slider = this.querySelector('.recently-viewed-product-slider');
        this.init();
    }

    init() {

        const productTemplateId = 'index-recently-viewed-product-template'
        const wrapperId = this.slider.id;

        const list = Shopify.Products.getList() || [];

        //show section
        if (list.length > 0) {

            this.show();

            if (list.length == 1) {
                this.slider.classList.add('has-only-one-item')
            }
        } else {
            return
        }

        Shopify.Products.showRecentlyViewed({
            wrapperId: wrapperId,
            templateId: productTemplateId,
            onComplete: this.loadComplete.bind(this)
        })
    }

    show() {
        this.wrapper.style.display = "block";
    }

    loadComplete() {
        console.log('slider', this.slider)

        const slider = this.slider;
        if (!slider) return;

        const initFlickity = () => {
            const flkty = new Flickity(slider, {
                cellAlign: 'left',
                contain: true,
                wrapAround: false,
                pageDots: true,
                prevNextButtons: true,
                draggable: true,
                imagesLoaded: true
            });

            // Flickity 2.1.2 stamps aria-selected on the cells, but no role that
            // supports aria-selected fits a plain product-card div, so audits flag
            // it (aria-allowed-attr). Strip it after init and after every 'select'
            // (both documented APIs) rather than patching the library.
            const stripCellAriaSelected = () => {
                flkty.getCellElements().forEach(function (el) {
                    el.removeAttribute('aria-selected');
                });
            };
            stripCellAriaSelected();
            flkty.on('select', stripCellAriaSelected);

            slider.dataset.flickityInitialized = 'true';
            slider.classList.add('flickity-initialized');
        };

        if (window.theme && window.theme.whenFlickityReady) {
            window.theme.whenFlickityReady(initFlickity);
        } else if (window.Flickity) {
            initFlickity();
        }

        //call parallax after
        //this.parallax();

    }

    /*
    parallax(){
        jarallaxElement();
        jarallax(this.container);
        console.log('recent init parallax');
    }
    */
  

}
  
  customElements.define('index-recently-viewed', IndexRecentlyViewed);

  // A11y: the recently-viewed "add to bag" control is a <span role="button"> injected
  // dynamically; its add-to-cart click is delegated on document, so make it keyboard
  // operable (Enter/Space) via a delegated keydown that forwards to a click.
  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (
      t && t.classList && t.classList.contains('recently-viewed-btn') &&
      (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32)
    ) {
      e.preventDefault();
      t.click();
    }
  });
